import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import BookmarkIcon from 'shared/components/birch/icons/bookmark';
import BookmarkFilledIcon from 'shared/components/birch/icons/bookmark_filled';
import { IconButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { standardRequestWithFlash } from 'shared/utils/request';
import { CustomIconTooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { type Person } from 'talent_matching/types';
import { useUpdatePerson } from 'talent_matching/hooks/use_people';

const t = withLocalePrefix('talent_matching');

const Bookmark = ({
  className,
  application,
  size,
  isFlat = true,
}: {
  className?: string;
  application: Person;
  size: 'sm' | 'md' | 'lg' | 'seedling-only-sm';
  isFlat?: boolean;
}) => {
  const updatePerson = useUpdatePerson();

  const toggleBookmark = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    // Optimistically update the UI
    updatePerson({ ...application, isBookmarked: !application.isBookmarked });

    try {
      if (application.isBookmarked) {
        await standardRequestWithFlash.delete('/bookmark', {
          data: { application_id: application.id },
        });
      } else {
        await standardRequestWithFlash.post('/bookmark', {
          application_id: application.id,
        });
      }
    } catch {
      // Rollback UI update on error
      updatePerson({
        ...application,
        isBookmarked: application.isBookmarked,
      });
    }
  };

  const Icon = application.isBookmarked ? BookmarkFilledIcon : BookmarkIcon;
  const tooltip = application.isBookmarked
    ? t('bookmarks.tooltips.remove_bookmark')
    : t('bookmarks.tooltips.add_bookmark');

  return (
    <div className={'candidate-bookmark ' + (className || '')}>
      <CustomIconTooltip label={tooltip} ariaLabel={tooltip}>
        <IconButton
          icon={Icon}
          label={t('bookmark')}
          onClick={toggleBookmark}
          size={size}
          flat={isFlat}
        />
      </CustomIconTooltip>
    </div>
  );
};

export default Bookmark;
